import { render, staticRenderFns } from "./document-automation-request-title.vue?vue&type=template&id=f5380ae0"
import script from "./document-automation-request-title.vue?vue&type=script&lang=ts"
export * from "./document-automation-request-title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports